/**
 * Authentication utility functions for client-side auth state checks.
 */

/**
 * Synchronously check if a session indicator cookie is present.
 * Quick check for routing decisions - does NOT validate the token.
 *
 * This checks for the `has_session` cookie which is set alongside
 * the HttpOnly auth cookies. Unlike the auth tokens, this cookie
 * is readable by JavaScript (not HttpOnly) but contains no sensitive data.
 *
 * Used by isPublicRoute() to make instant routing decisions
 * without waiting for async session fetching.
 */
export function hasAuthCookie(): boolean {
  // Check for session indicator cookie (not HttpOnly, readable by JS)
  return document.cookie.includes("has_session=1");
}
